export const countries = [
  {
    countryId: 1,
    name: 'USA',
    description: null,
    id: 1,
  },
];
export const singleCountry = {
  id: 1,
  name: 'USA',
  description: null,
  createdAt: '2019-09-09T20:47:41.402Z',
  updatedAt: '2021-06-18T22:51:27.215Z',
  languageId: 1,
  countryId: 1,
  createdBy: null,
  updatedBy: 1,
};
